<!--
/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software: you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation, either
 * version 3 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with OrangeHRM.
 * If not, see <https://www.gnu.org/licenses/>.
 */
 -->

<template>
  <span
    v-if="tone"
    :class="['anna-stage', 'list-pill', `anna-tone--${tone}`]"
    :title="title"
    >{{ label }}</span
  >
  <span v-else class="list-plain" :title="label">{{ label }}</span>
</template>

<script>
// Card-table cell for the Candidates list's Stage: an undecided candidate's stage with Anna as a
// coloured pill ({label, title, tone}: short, the whole label on hover); a decided one's status as plain text.
export default {
  name: 'AnnaStageCell',
  props: {
    item: {
      type: [Object, String],
      required: false,
      default: '',
    },
  },
  computed: {
    label() {
      return typeof this.item === 'string' ? this.item : this.item?.label;
    },
    title() {
      return typeof this.item === 'string'
        ? this.item
        : this.item?.title || this.label;
    },
    tone() {
      return typeof this.item === 'string' ? null : this.item?.tone;
    },
  },
};
</script>

<style lang="scss" scoped src="./anna-tones.scss"></style>
<style lang="scss" scoped>
// one line in the list: cut with "…" if it still doesn't fit (inline-flex can't be cut)
.list-pill,
.list-plain {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: middle;
}
</style>
